import { CurrentPayPlan, MembershipLevel, MembershipProductType } from '@ace-clublabs/common-membership-api-types';
import { IFormData, IMemberDetails } from '../state/model';
import { MSSMembers, MSSProductStatus } from '@lib/types';
import dayjs from 'dayjs';

export const getRVProductRule = (membershipDetails: IMemberDetails, membershipLevel: MembershipLevel) => {
  const rvProduct = membershipDetails.prospectiveMemberRules.memberProducts.find(
    (memberProduct) => memberProduct.productType === MembershipProductType.RV
  );

  const rvRules = rvProduct?.productRules;
  return rvRules?.find((rvRule) => rvRule.membershipLevel === membershipLevel)?.rule;
};

export const getRVWillBeIncluded = (membershipDetails: IMemberDetails, membershipLevel: MembershipLevel) => {
  const rvProduct = membershipDetails.prospectiveMemberRules.memberProducts.find(
    (memberProduct) => memberProduct.productType === MembershipProductType.RV
  );
  return rvProduct?.productRules?.some(
    (rvRule) => rvRule.membershipLevel === membershipLevel && rvRule.rule === MSSProductStatus.INCLUDED
  );
};

export const getIsInMidterm = (membershipDetails: IMemberDetails) => {
  const { inRenewal, inArrears, inGrace } = membershipDetails;

  const isInMidterm = !inRenewal && !inArrears && !inGrace;
  return isInMidterm;
};

export const isRVAdded = (formData: IFormData) => {
  if (!formData.products || formData.products?.length === 0) {
    return false;
  }

  const rvProduct = formData.products.find((product) => product.type === MembershipProductType.RV);
  const rvProductIsAdded = rvProduct?.status === MSSProductStatus.ADDED;
  return rvProductIsAdded;
};

export const getTermPeriodText = (inRenewal: boolean, billPlan: CurrentPayPlan) => {
  if (billPlan === CurrentPayPlan.RECURRINGMONTHLY) return 'month';
  return inRenewal ? 'full year' : 'remaining term';
};

export const isMonthlyPastDue = (membershipDetails: IMemberDetails) => {
  const { monthlyPastDue, hasPaymentInTransit } = membershipDetails;
  return monthlyPastDue! > 0 && !hasPaymentInTransit;
};

export const checkIfMembersMatch = (mem1: MSSMembers, mem2: MSSMembers) => {
  const stringifyMember = ({ firstName, lastName, dateOfBirth, roleType }: MSSMembers) => {
    return `${firstName.toLowerCase()} ${lastName.toLowerCase()} ${dayjs(dateOfBirth).format(
      'YYYY-MM-DD'
    )} ${roleType}`;
  };

  return stringifyMember(mem1) === stringifyMember(mem2);
};

export const hasPITOrPendingChange = (membershipDetails: IMemberDetails) => {
  const hasPIT = membershipDetails?.hasPaymentInTransit;
  const date = new Date();
  const currentDateInPST = date.toLocaleString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'America/Los_Angeles',
  });

  const hasPendingChange = membershipDetails?.pendingProducts?.some((product: any) => {
    return product?.effectiveDate > currentDateInPST;
  });
  return hasPIT || hasPendingChange;
};
